module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/637d5d767b1a3cd7dfe33b8db64927e6.png";